module.exports = __webpack_public_path__ + "786f855a0819e01fc31f37a596464b29.svg";